<div class="mr-1! flex items-start">
  @if(logo()) {
  <div>
    <img [src]="logo()" alt="Logo" class="w-10 rounded-[10px]" />
  </div>
  }
  <div [class]="ui.mediaBody">
    <strong [textContent]="name() || ''"></strong><br />
    <p [class]="ui.role">{{ userRole() }}<i class="fa fa-angle-down {{ui.roleIcon}}"></i></p>
  </div>
  <!-- Phones hide the name above, so this is the only thing left to tap to reach the menu (log out). -->
  <app-feather-icons icon="user" width="22" class="hidden max-md:block"></app-feather-icons>
</div>
<ul [class]="ui.dropdown" data-testid="profile-dropdown">
  <li [class]="ui.dropdownItem">
    <button
      type="button"
      (click)="logOut()"
      class="w-full cursor-pointer btn-bare text-left text-body tracking-theme [font-family:inherit] [font-size:inherit]"
    >
      <app-feather-icons [icon]="'log-out'" [class]="ui.dropdownIcon"></app-feather-icons>
      <span class="text-(--dark-color)">{{ 'PROFILE_MENU.LOGOUT' | translate }}</span>
    </button>
  </li>
</ul>
